import pyClient from '../PyAPI_Config'

async function get(authState: any, path: string) {
  return await pyClient(authState)
    .get<any>('/study' + path)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function post(authState: any, path: string, payload?: any) {
  return await pyClient(authState)
    .post<any>(`/study` + path, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getStudyCollections(authState: any, study_id: string) {
  return await pyClient(authState)
    .get<any>(`/study/${study_id}/collections`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getMetaAnimalAttributes(authState: any) {
  return await pyClient(authState)
    .get<any>(`/study/metadata/study_animal_attrs`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getMetaExportFormats(authState: any) {
  return await pyClient(authState)
    .get<any>(`/study/metadata/export_formats`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function updateStudy(
  authState: any,
  study_id: string | number,
  data: Record<string, any>,
) {
  return await pyClient(authState)
    .patch<any>(`/study/${study_id}`, data)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function addProtocol(
  authState: any,
  study_id: string,
  protocolID: number,
) {
  return await pyClient(authState)
    .put<any>(`/study/${study_id}/protocol?protocol_id=${protocolID}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

// async function getStudyAnimals(
//   authState: any,
//   study_id: number,
//   includeCulled: boolean,
// ) {
//   return await pyClient(authState)
//     .get<any>(`/study/${study_id}/animals?include_culled=${includeCulled}`)
//     .then((response) => response.data)
//     .catch((error) => Promise.reject(error.response))
// }

async function enrollStudyAnimals(
  authState: any,
  study_id: string,
  UAIs: number[],
) {
  return await pyClient(authState)
    .post<any>(`/study/${study_id}/animals`, UAIs)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function updateAnimalPhase(
  authState: any,
  study_id: string,
  phase_id: string,
  UAIs: number[],
) {
  return await pyClient(authState)
    .patch<any>(`/study/${study_id}/animals/phase?phase_id=${phase_id}`, UAIs)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const StudyService = {
  get,
  updateStudy,
  post,
  addProtocol,
  updateAnimalPhase,
  enrollStudyAnimals,
  getMetaAnimalAttributes,
  getStudyCollections,
  getMetaExportFormats,
}

export default StudyService
